(function ()
{
	"use strict";

	function SettingShip()
	{
		this.Container_constructor();
		this.captionsContainer = new cjs.Container();
		this.name = "SettingShip";
		this.width = cm.app.display.width * 0.5;
		this.height = cm.app.display.height * 0.5;
		this.challengeArray = [];
		this.y = this.height * 2;
		this.inactivityTimer = 0;
		this.checkStorages();
		this.addBgShape();
		this.addShip();
		this.addButtons();
		this.addBackButton();
		this.setupHitAreas();
		this.visible = false;
		this.ccIsPressMove = false;
		this.clickSoundPlay = false;
		cjs.Tween.get(this).wait(1000).call(this.setupKeyNav, null, this);
	}

	var p = createjs.extend(SettingShip, cjs.Container);

	p.checkStorages = function ()
	{
		var shipSettings = localStorage.getItem('shipSettings');
		if (shipSettings === null) {
			shipSettings = {
				musicVolume: 0.17,
				sfxVolume: 1,
				voVolume: 1,
				speedPos: 1,
				speed: 1,
				difficulty: 1,
				ccSettings: true
			};
			this.storedShipSettings = shipSettings;
			localStorage.setItem('shipSettings', JSON.stringify(shipSettings));
		} else {
			this.storedShipSettings = JSON.parse(shipSettings);
		}

		cm.main.musicVolume = this.storedShipSettings.musicVolume;
		cm.main.sfxVolume = this.storedShipSettings.sfxVolume;
		cm.main.voVolume = this.storedShipSettings.voVolume;
		cm.main.speedPos = this.storedShipSettings.speedPos;
		cm.main.speed = this.storedShipSettings.speed;
		cm.main.difficulty = this.storedShipSettings.difficulty;
		cm.main.ccSettings = this.storedShipSettings.ccSettings;
	};

	p.setupHitAreas = function ()
	{
		var posArray = [{ x: -46, y: -275 }, { x: -12, y: -275 }, { x: 20, y: -275 }, { x: 54, y: -275 }, { x: 86, y: -275 }, { x: 117, y: -275 }, { x: 155, y: -275 },
		{ x: -46, y: -155 }, { x: -12, y: -155 }, { x: 20, y: -155 }, { x: 54, y: -155 }, { x: 86, y: -155 }, { x: 117, y: -155 }, { x: 155, y: -155 },
		{ x: -46, y: -30 }, { x: -12, y: -30 }, { x: 20, y: -30 }, { x: 54, y: -30 }, { x: 86, y: -30 }, { x: 117, y: -30 }, { x: 155, y: -30 }];
		var i, l, g, hG, shape, hitShape;
		for (i = 0, l = posArray.length; i < l; i++) {
			g = new cjs.Graphics();
			g.f("blue").r(0, 0, 25, 75);
			shape = new cjs.Shape(g);
			shape.x = posArray[i].x - 12;
			shape.y = posArray[i].y;


			hG = new cjs.Graphics();
			hG.r(0, 0, 0, 0);
			hitShape = new cjs.Shape(hG);
			if (i < 7)
				hitShape.name = "music";
			if (i > 6 && i < 14)
				hitShape.name = "sound";
			if (i > 13)
				hitShape.name = "voice";

			hitShape.positionNum = i;

			hitShape.hitArea = shape;
			hitShape.on("click", this.pressUpHandler, this);
			this.addChild(hitShape);
		}

		posArray = [{ x: 325, y: -190 }, { x: 325, y: -20 }, { x: 325, y: 160 }];
		for (i = 0, l = posArray.length; i < l; i++) {
			g = new cjs.Graphics();
			g.f("blue").r(0, 0, 75, 100);
			shape = new cjs.Shape(g);
			shape.x = posArray[i].x;
			shape.y = posArray[i].y;


			hG = new cjs.Graphics();
			hG.r(0, 0, 0, 0);
			hitShape = new cjs.Shape(hG);
			hitShape.name = "speed";
			hitShape.positionNum = i;

			hitShape.hitArea = shape;
			hitShape.on("click", this.pressUpHandler, this);
			this.addChildAt(hitShape, 8);
		}
	};

	p.pressUpHandler = function (e)
	{
		this.inactivityTimer = 0;
		var posArray = [-46, -12, 20, 54, 86, 119, 137];
		var button = e.target;
		switch (button.name) {
			case "captions":
				if (this.ccIsPressMove) {
					this.ccIsPressMove = false;
					return;
				}

				var bg = this.captionsContainer.getChildAt(0);
				var nob = this.captionsContainer.getChildAt(1);
				if (nob.x === -410) {
					bg.x = nob.x = -319;
					this.storedShipSettings.ccSettings = cm.main.ccSettings = false;
					app.voPlayer.play([100, "vo-131"]);

					if (!app.container.connected){
						app.captions.mute = cm.main.ccSettings;
						cm.main.preloadVideo();
					}
				} else {
					bg.x = nob.x = -410;
					this.storedShipSettings.ccSettings = cm.main.ccSettings = true;
					app.voPlayer.play([100, "vo-132"]);
					if (!app.container.connected){
						app.captions.mute = cm.main.ccSettings;
						cm.main.preloadVideo();
					}
				}
				break;
			case "music":

				var musicBtn = this.getChildAt(3);
				musicBtn.positionNum = button.positionNum;
				musicBtn.x = posArray[button.positionNum];
				musicBtn.maskShape.x = musicBtn.x + 15;
				if (musicBtn.positionNum === 6)
					musicBtn.maskShape.x = musicBtn.x + 37;
				this.handleVolume(musicBtn.name, musicBtn.positionNum);
				break;
			case "sound":
				var soundBtn = this.getChildAt(5);
				soundBtn.positionNum = button.positionNum - 7;
				soundBtn.x = posArray[button.positionNum - 7];
				soundBtn.maskShape.x = soundBtn.x + 15;
				if (soundBtn.positionNum === 6)
					soundBtn.maskShape.x = soundBtn.x + 37;
				this.handleVolume(soundBtn.name, soundBtn.positionNum);
				break;
			case "voice":
				var voiceBtn = this.getChildAt(7);
				voiceBtn.positionNum = button.positionNum - 14;
				voiceBtn.x = posArray[button.positionNum - 14];
				voiceBtn.maskShape.x = voiceBtn.x + 15;
				if (voiceBtn.positionNum === 6)
					voiceBtn.maskShape.x = voiceBtn.x + 37;
				this.handleVolume(voiceBtn.name, voiceBtn.positionNum);
				break;
			case "speed":
				var speedBtn = this.getChildAt(11);
				this.playClick();
				posArray = [-96, 28, 160];
				var speedVOArray = [
					"vo-159",
					"vo-158",
					"vo-157"
				];
				speedBtn.y = posArray[button.positionNum];
				app.voPlayer.play([100, speedVOArray[button.positionNum]]);
				speedBtn.positionNum = button.positionNum;
				this.setSpeed(speedBtn.positionNum);
				this.storedShipSettings.speedPos = cm.main.speedPos = speedBtn.positionNum;
				break;
		}
	};

	p.setupKeyNav = function ()
	{
		this.keyNav = cm.ViewControl.current.keyNav;
		var pos = [{ x: -360, y: -200 }, { x: -200, y: -230 }, { x: -200, y: -120 }, { x: -200, y: 0 }, { x: 360, y: -260 }, { x: 0, y: 150 }];
		var name = ["caption", "music", "sound", "voice", "speed", "challenge"];
		var arrowPos = ["down", "right", "right", "right", "down", "down"];
		for (var i = 0, l = 6; i < l; i++) {
			var g = new cjs.Graphics();
			g.f("blue").r(0, 0, 100, 50);
			var shape = new cjs.Shape(g);
			shape.x = pos[i].x;
			shape.y = pos[i].y;
			shape.name = name[i];
			shape.placeArrow = arrowPos[i];
			shape.setBounds(0, 0, 50, 50);
			this.keyNav.settingsButtons.push(shape);
		}
		this.keyNav.settingsButtons.push(this.backBtnContainer);
	};

	p.addBgShape = function ()
	{
		var bgGraphic = new cjs.Graphics();
		bgGraphic.f("#000").r(0, 0, cm.app.display.width, cm.app.display.height);
		this.backGroundShape = new cjs.Shape(bgGraphic);
		this.backGroundShape.regX = cm.app.display.width * 0.5;
		this.backGroundShape.regY = cm.app.display.height * 0.5;
		this.backGroundShape.alpha = 0;
		this.backGroundShape.y = -768 - 11;
		this.backGroundShape.on("mousedown", function () { });
		this.addChild(this.backGroundShape);
	};

	p.addShip = function ()
	{
		var shipBg = new cjs.Bitmap(cm.Assets.lib.settingsBg).center();
		shipBg.y = -11;
		shipBg.on("mousedown", function () { });
		this.addChild(shipBg);
	};

	p.addButtons = function ()
	{
		var spriteArray = ["sound-btn", "sound-btn", "sound-btn", "speed-tab", "easy-btn", "medium-btn", "hard-btn"];
		var nameArray = ["musicBtn", "soundBtn", "voBtn", "speed-tab", "easy-btn", "medium-btn", "hard-btn"];
		var pos = [{ x: -46, y: -190 }, { x: -46, y: -67 }, { x: -46, y: 59 }, { x: 358, y: 28 }, { x: -150, y: 252 }, { x: 0, y: 252 }, { x: 150, y: 252 }];
		for (var i = 0, l = spriteArray.length; i < l; i++) {
			var sprite = spriteArray[i];
			var button = new cjs.Sprite(cm.Assets.lib.gameSS, sprite).set({ x: pos[i].x, y: pos[i].y, name: nameArray[i] }).center();
			if (i < 3) {
				this.addSoundUI(button);
			}
			if (nameArray[i] === "speed-tab")
				this.speedTabSetup(button);
			if (i > 3) {
				this.setupChallengeButtons(button, i);
			}
			this.addChild(button);
		}
		this.createCaptionsBtn();
	};

	p.addBackButton = function ()
	{
		this.backBtnContainer = new cjs.Container();
		var backBg = new cjs.Sprite(cm.Assets.lib.mapSS, "settings-bg").center();
		backBg.set({ name: "back-btn" });
		var backBtn = new cjs.Sprite(cm.Assets.lib.gameSS, "settings-back-btn").center();
		backBtn.set({ name: "settings-btn", snapToPixel: false, x: -3, y: 2 });
		this.backBtnContainer.set({ x: -this.width + 98, y: -400, name: "back-to-game" });
		this.backBtnContainer.addChild(backBg, backBtn);
		this.backBtnContainer.placeArrow = "up";
		backBg.on("mouseover", this.buttonHandler, this);
		backBg.on("mousedown", this.buttonHandler, this);
		backBg.on("click", this.buttonHandler, this);
		this.backBtnContainer.visible = false;
		this.addChild(this.backBtnContainer);
	};

	p.setupChallengeButtons = function (button, num)
	{
		this.challengeArray.push(button);
		button.positionNum = Math.abs(4 - num);
		var diffArray = [1, 0.75, 0.5];
		button.difficultyNum = diffArray[button.positionNum];
		button.on("mousedown", this.buttonHandler, this);
		this.handleChallengeButtons(cm.main.difficulty);
	};

	p.handleChallengeButtons = function (num)
	{
		var btn;
		var challengeVoArray =
			[
				"vo-154",
				"vo-155",
				"vo-156"
			];
		for (var i = 0, l = this.challengeArray.length; i < l; i++) {
			btn = this.challengeArray[i];
			if (btn.difficultyNum === num) {
				btn.gotoAndPlay(btn.name + "-press");
				this.storedShipSettings.difficulty = cm.main.difficulty = btn.difficultyNum;
				if (this.y < this.height * 2)
					app.voPlayer.play(challengeVoArray[i]);
			}
			else {
				btn.gotoAndPlay(btn.name);
			}
		}
	};

	p.speedTabSetup = function (btn)
	{
		btn.on("pressmove", this.buttonHandler, this);
		var posArray = [-96, 28, 160];
		btn.positionNum = cm.main.speedPos;
		btn.y = posArray[btn.positionNum];
	};

	p.addSoundUI = function (btn)
	{
		var soundUI = new cjs.Sprite(cm.Assets.lib.gameSS, "volume-settings").set({ x: btn.x - 13, y: btn.y - 82, name: "soundUI" });
		this.createSoundUIMask(soundUI, btn);
		this.addChild(soundUI);
		btn.on("pressmove", this.buttonHandler, this);
		this.getCurrentVolume(btn);
	};

	p.getCurrentVolume = function (btn)
	{
		var posArray = [-46, -12, 20, 54, 86, 119, 137];
		var pos = 0;
		var i, l;
		switch (btn.name) {
			case "musicBtn":
				for (i = 0, l = cm.main.musicVolume; i < l; i += 0.17) {
					pos++;
				}
				break;
			case "soundBtn":
				for (i = 0, l = cm.main.sfxVolume; i < l; i += 0.17) {
					pos++;
				}
				break;

			case "voBtn":
				for (i = 0, l = cm.main.voVolume; i < l; i += 0.17) {
					pos++;
				}
				break;
		}

		btn.x = posArray[pos];
		btn.maskShape.x = btn.x + 15;
		btn.positionNum = pos;
		if (pos === 6)
			btn.maskShape.x = btn.x + 37;
	};



	p.createSoundUIMask = function (ui, btn)
	{
		var m = new cjs.Graphics();
		m.f("#fff").r(0, 0, 240, 85);
		var maskFillShape = new cjs.Shape(m);
		maskFillShape.set({ x: btn.x + 15, y: ui.y - 5, alpha: 0.5, regX: 240 });
		btn.maskShape = maskFillShape;
		ui.mask = maskFillShape;
	};

	p.createCaptionsBtn = function ()
	{
		var ccBg = new cjs.Sprite(cm.Assets.lib.gameSS, "captions-btn").set({ x: -319, y: -3, name: "captions" }).center();
		this.createMaskShape(ccBg);
		var ccBtn = new cjs.Sprite(cm.Assets.lib.gameSS, "captions-top-btn").set({ x: -319, y: -3, name: "captions" }).center();
		this.captionsContainer.addChild(ccBg, ccBtn);

		ccBtn.on("pressmove", this.buttonHandler, this);
		this.captionsContainer.on("click", this.pressUpHandler, this);

		if (cm.main.ccSettings)
			ccBtn.x = ccBg.x = -410;
		else
			ccBtn.x = ccBg.x = -319;


		this.addChild(this.captionsContainer);
	};

	p.buttonHandler = function (e)
	{
		var icon;
		var mouseX = e.stageX - this.width;
		var mouseY = e.stageY - this.height;
		this.inactivityTimer = 0;
		if (e.type === "pressmove") {
			if (e.target.name === "captions") {
				var child;

				if (mouseX < e.target.x) {
					child = e.target.parent.getChildAt(0);
					if (e.target.x !== -410) {
						this.playClick();
					}
					child.x = e.target.x = -410;
					this.storedShipSettings.ccSettings = cm.main.ccSettings = true;
					app.voPlayer.play([100, "vo-132"]);
					this.ccIsPressMove = true;
					if (app.container.connected !== true)
						app.captions.mute = cm.main.ccSettings;
				}
				if (mouseX > e.target.x) {
					child = e.target.parent.getChildAt(0);
					if (e.target.x !== -319) {
						this.playClick();
					}
					child.x = e.target.x = -319;
					this.storedShipSettings.ccSettings = cm.main.ccSettings = false;
					app.voPlayer.play([100, "vo-131"]);
					this.ccIsPressMove = true;
					if (app.container.connected !== true)
						app.captions.mute = cm.main.ccSettings;
				}
			}

			if (e.target.name === "musicBtn" || e.target.name === "soundBtn" || e.target.name === "voBtn") {
				this.handleSoundBtn(e);
			}
			if (e.target.name === "speed-tab") {
				this.handleSpeedBtn(e);
			}
		}

		if (e.type === "mousedown") {

			if (e.target.name === "easy-btn" || e.target.name === "medium-btn" || e.target.name === "hard-btn") {
				cm.app.sound.play("grab");
				this.handleChallengeButtons(e.target.difficultyNum);
			} else {
				icon = e.target.parent.getChildAt(1);
				cjs.Tween.get(icon).to({ scaleX: 0.9, scaleY: 0.9 }, 150, cjs.Ease.backOut);
			}
		}
		if (e.type === "click") {
			cm.app.sound.play("click-1");
			icon = e.target.parent.getChildAt(1);
			cjs.Tween.get(icon).to({ scaleX: 1, scaleY: 1 }, 150, cjs.Ease.backOut).call(this.animateOut, null, this);
		}
		if (e.type === "mouseover") {
			if (e.target.name === "back-btn") {
				app.voPlayer.play("vo-130");
				icon = e.target.parent.getChildAt(1);
				cjs.Tween.get(icon).to({ scaleX: 1.1, scaleY: 1.1 }, 150, cjs.Ease.backOut);
			}
		}
		if (e.type === "mouseout") {
			if (e.target.name === "back-btn") {
				icon = e.target.parent.getChildAt(1);
				cjs.Tween.get(icon).to({ scaleX: 1, scaleY: 1 }, 150, cjs.Ease.backOut);
			}
		}
	};
	p.playClick = function ()
	{
		if (this.clickSoundPlay) { return; }
		cm.app.sound.play("grab");
		this.clickSoundPlay = true;
		cjs.Tween.get(this).wait(500).set({ clickSoundPlay: false });
	};

	p.handleSpeedBtn = function (e)
	{
		var mouseY = e.stageY - this.height;
		var posArray = [-96, 28, 160];
		// var posArray = [-100,-39, 28, 111, 160]; ///incase we need 5 total speeds instead of 3
		var speedVOArray = [
			"vo-159",
			"vo-158",
			"vo-157"
		];
		if (mouseY < e.target.y) {
			if (e.target.positionNum > 0) {
				this.playClick();
				e.target.positionNum--;
				e.target.y = posArray[e.target.positionNum];
				app.voPlayer.play([100, speedVOArray[e.target.positionNum]]);
				this.storedShipSettings.speedPos = cm.main.speedPos = e.target.positionNum;
			}
		}

		if (mouseY > e.target.y) {
			if (e.target.positionNum < 2) {
				this.playClick();
				e.target.positionNum++;
				e.target.y = posArray[e.target.positionNum];
				app.voPlayer.play([100, speedVOArray[e.target.positionNum]]);
				this.storedShipSettings.speedPos = cm.main.speedPos = e.target.positionNum;
			}
		}
		this.setSpeed(e.target.positionNum);
	};

	p.setSpeed = function (posNum)
	{
		switch (posNum) {
			case 0:
				this.storedShipSettings.speed = cm.main.speed = 1.5;
				break;
			case 1:
				this.storedShipSettings.speed = cm.main.speed = 1;
				break;
			case 2:
				this.storedShipSettings.speed = cm.main.speed = 0.5;
				break;
		}
	};

	p.handleSoundBtn = function (e)
	{
		var mouseX = e.stageX - this.width;
		var posArray = [-46, -12, 20, 54, 86, 119, 137];

		if (mouseX < e.target.x) {
			if (e.target.positionNum > 0) {
				e.target.positionNum--;
				e.target.x = posArray[e.target.positionNum];
				e.target.maskShape.x = e.target.x + 15;
				this.handleVolume(e.target.name, e.target.positionNum);
			}
		}

		if (mouseX > e.target.x) {
			if (e.target.positionNum < 6) {
				e.target.positionNum++;
				e.target.x = posArray[e.target.positionNum];
				e.target.maskShape.x = e.target.x + 15;
				if (e.target.positionNum === 6)
					e.target.maskShape.x = e.target.x + 37;
				this.handleVolume(e.target.name, e.target.positionNum);
			}
		}
	};

	p.handleVolume = function (name, num)
	{
		var voVolume = [];
		var volume = 0.17 * num;
		if (volume > 1)
			volume = 1;
		this.playClick();
		switch (name) {
			case "musicBtn":
				app.musicInstance.volume = this.storedShipSettings.musicVolume = cm.main.musicVolume = volume;
				app.sound.setContextVolume("music", volume);
				voVolume = [
					"vo-133",
					"vo-134",
					"vo-135",
					"vo-136",
					"vo-137",
					"vo-138",
					"vo-139"
				];
				app.voPlayer.play([100, voVolume[num]]);

				break;
			case "soundBtn":
				this.storedShipSettings.sfxVolume = cm.main.sfxVolume = volume;
				app.sound.setContextVolume("sfx", volume);
				voVolume = [
					"vo-140",
					"vo-141",
					"vo-142",
					"vo-143",
					"vo-144",
					"vo-145",
					"vo-146"
				];
				app.voPlayer.play([100, voVolume[num]], this.playSfxSound.bind(this));
				break;
			case "voBtn":
				this.storedShipSettings.voVolume = cm.main.voVolume = volume;
				voVolume = [
					"vo-147",
					"vo-148",
					"vo-149",
					"vo-150",
					"vo-151",
					"vo-152",
					"vo-153"
				];
				if (volume >= 0.17) {
					app.sound.setContextVolume("vo", volume);
					app.voPlayer.play([100, voVolume[num]]);
				} else {
					app.voPlayer.play([100, voVolume[num]]);
					cjs.Tween.get(this).wait(2000).call(this.muteVO, null, this);
				}

				break;
		}
	};
	p.muteVO = function ()
	{
		app.sound.setContextVolume("vo", 0);
	};

	p.playSfxSound = function ()
	{
		app.sound.play("collect-1");
	};

	p.animateIn = function ()
	{
		this.visible = true;
		this.addChild(cm.ViewControl.current.navArrow);
		var tweenAmount;
		if (cm.ViewControl.currentID === "SpaceView")
			tweenAmount = 11;
		else
			tweenAmount = 16;
		cjs.Tween.get(this.backGroundShape).to({ alpha: 0.5, y: -11 }, 500, cjs.Ease.quadOut);
		cjs.Tween.get(this).to({ y: tweenAmount }, 500, cjs.Ease.quadOut).call(this.animateBackBtnIn, null, this);
	};

	p.animateBackBtnIn = function ()
	{
		// this.backGroundShape.visible = true;
		cjs.Tween.get(this.backBtnContainer).set({ visible: true }).call(cm.app.sound.play, ["button-drop"], cm.app.sound).to({ y: -341 }, 250, cjs.Ease.quadOut);
	};
	p.animateBackBtnOut = function ()
	{
		cjs.Tween.get(this.backBtnContainer).call(cm.app.sound.play, ["button-drop"], cm.app.sound).to({ y: -400 }, 250, cjs.Ease.quadIn).set({ visible: false });
	};

	p.setShipSettingsVisibility = function ()
	{
		this.visible = false;
	};

	p.animateOut = function ()
	{
		localStorage.setItem('shipSettings', JSON.stringify(this.storedShipSettings));
		// this.backGroundShape.visible = false;
		cjs.Tween.get(this.backGroundShape).wait(250).to({ alpha: 0, y: -768 - 11 }, 500, cjs.Ease.quadIn);
		if (cm.ViewControl.currentID === "SpaceView")
			cjs.Tween.get(this).call(this.animateBackBtnOut, null, this).wait(250).to({ y: this.height * 2 }, 500, cjs.Ease.quadIn).set({ visible: false }).call(this.parent.closeSettingShip, null, this.parent);
		else
			cjs.Tween.get(this).call(this.animateBackBtnOut, null, this).wait(250).to({ y: this.height * 2 }, 500, cjs.Ease.quadIn).set({ visible: false }).call(this.parent.shipSettingsClose, null, this.parent);

	};

	p.handleKeySelect = function (button)
	{
		var posArray = [-46, -12, 20, 54, 86, 119, 137];
		this.inactivityTimer = 0;
		switch (button.name) {
			case "caption":
				cm.app.sound.play("grab");
				var bg = this.captionsContainer.getChildAt(0);
				var nob = this.captionsContainer.getChildAt(1);
				if (nob.x === -410) {
					bg.x = nob.x = -319;
					this.storedShipSettings.ccSettings = cm.main.ccSettings = false;
					app.voPlayer.play([100, "vo-131"]);
					if (app.container.connected !== true)
						app.captions.mute = cm.main.ccSettings;
				} else {
					bg.x = nob.x = -410;
					this.storedShipSettings.ccSettings = cm.main.ccSettings = true;
					app.voPlayer.play([100, "vo-132"]);
					if (app.container.connected !== true)
						app.captions.mute = cm.main.ccSettings;
				}
				break;
			case "music":
				var musicBtn = this.getChildAt(3);
				cm.app.sound.play("grab");
				musicBtn.positionNum++;
				if (musicBtn.positionNum > 6)
					musicBtn.positionNum = 0;
				musicBtn.x = posArray[musicBtn.positionNum];
				musicBtn.maskShape.x = musicBtn.x + 15;
				if (musicBtn.positionNum === 6)
					musicBtn.maskShape.x = musicBtn.x + 37;
				this.handleVolume(musicBtn.name, musicBtn.positionNum);
				break;
			case "sound":
				var soundBtn = this.getChildAt(5);
				cm.app.sound.play("grab");
				soundBtn.positionNum++;
				if (soundBtn.positionNum > 6)
					soundBtn.positionNum = 0;
				soundBtn.x = posArray[soundBtn.positionNum];
				soundBtn.maskShape.x = soundBtn.x + 15;
				if (soundBtn.positionNum === 6)
					soundBtn.maskShape.x = soundBtn.x + 37;
				this.handleVolume(soundBtn.name, soundBtn.positionNum);
				break;
			case "voice":
				var voiceBtn = this.getChildAt(7);
				cm.app.sound.play("grab");
				voiceBtn.positionNum++;
				if (voiceBtn.positionNum > 6)
					voiceBtn.positionNum = 0;
				voiceBtn.x = posArray[voiceBtn.positionNum];
				voiceBtn.maskShape.x = voiceBtn.x + 15;
				if (voiceBtn.positionNum === 6)
					voiceBtn.maskShape.x = voiceBtn.x + 37;
				this.handleVolume(voiceBtn.name, voiceBtn.positionNum);
				break;
			case "speed":
				cm.app.sound.play("grab");
				var speedBtn = this.getChildAt(11);
				posArray = [-96, 28, 160];
				var speedVOArray = [
					"vo-159",
					"vo-158",
					"vo-157"
				];

				speedBtn.positionNum++;
				if (speedBtn.positionNum > 2)
					speedBtn.positionNum = 0;
				speedBtn.y = posArray[speedBtn.positionNum];
				app.voPlayer.play([100, speedVOArray[speedBtn.positionNum]]);
				this.setSpeed(speedBtn.positionNum);
				this.storedShipSettings.speedPos = cm.main.speedPos = speedBtn.positionNum;
				break;
			case "challenge":
				cm.app.sound.play("grab");
				var indexNum = 0;
				for (var i = 0, l = this.challengeArray.length; i < l; i++) {
					var challengeButton = this.challengeArray[i];
					if (challengeButton.difficultyNum === cm.main.difficulty)
						indexNum = i;
				}
				var diffArray = [1, 0.75, 0.5];
				indexNum++;
				if (indexNum > 2)
					indexNum = 0;
				this.handleChallengeButtons(diffArray[indexNum]);
				break;
			case "back-to-game":
				this.animateOut();
				cm.ViewControl.current.navArrow.visible = false;
				break;
		}
	};

	p.playInactiveVO = function ()
	{
		app.voPlayer.play("vo-163");
	};

	p._tick = function (e)
	{
		if (this.visible) {
			this.inactivityTimer++;
			if (this.inactivityTimer > 600) {
				this.playInactiveVO();
				this.inactivityTimer = 0;
			}
		}
	};

	p.createMaskShape = function (btn)
	{
		var m = new cjs.Graphics();
		m.f("#fff").rc(0, 0, 168, 85, 40, 40, 40, 40);
		this.maskFillShape = new cjs.Shape(m);
		this.maskFillShape.set({ x: -449, y: -42, alpha: 0.5 });
		btn.mask = this.maskFillShape;
	};
	cm.SettingShip = cjs.promote(SettingShip, "Container");
})();
